import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable max-len */
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Box, FormControlLabel, RadioGroup, Radio, } from '@mui/material';
// import { clone } from 'lodash-es';
import { CancelOutlined, CheckCircle } from '@mui/icons-material';
import Explanation from './Explanation';
const SingleChoiceAnswer = ({ answers, correctAnswer, setAnswer, isSubmit, userAnswers, }) => {
    const setAnswerFn = (ev) => {
        setAnswer([ev.target.value]);
    };
    const getValue = () => {
        if (isSubmit) {
            return correctAnswer.length ? correctAnswer[0] : '';
        }
        return userAnswers.length ? userAnswers[0] : '';
    };
    // console.log('userAnswers: ', userAnswers);
    // console.log('userAnswers: ', answers);
    return (_jsx(Box, { sx: { ml: '5%' }, children: _jsx(RadioGroup, { "aria-labelledby": "demo-radio-buttons-group-label", value: getValue(), name: "radio-buttons-group", sx: {
                display: 'block',
            }, onChange: (ev) => setAnswerFn(ev), children: answers.map((answer) => (_jsxs(React.Fragment, { children: [_jsx(FormControlLabel, { value: answer.id, sx: {
                            width: '80%',
                            border: isSubmit && userAnswers.includes(answer.id)
                                ? correctAnswer.includes(answer.id)
                                    ? '2px solid green'
                                    : '2px solid red'
                                : '',
                            my: 1,
                        }, control: (_jsxs(_Fragment, { children: [isSubmit && !correctAnswer.includes(answer.id)
                                    && _jsx(CancelOutlined, { sx: { color: 'red', m: 1 } }), isSubmit && correctAnswer.includes(answer.id)
                                    && _jsx(CheckCircle, { sx: { color: 'green', m: 1 } }), !isSubmit && (_jsx(Radio, { sx: {
                                        color: '#007bad',
                                        '&$checked': {
                                            color: '#007bad',
                                        },
                                        '&$disabled': {
                                            color: '#007bad',
                                        },
                                    }, value: answer.id }))] })), disabled: isSubmit, label: answer.answerText }), isSubmit && Boolean(answer.explanation) && (_jsx(Explanation, { explanation: answer.explanation }))] }, answer.id))) }) }));
};
export default observer(SingleChoiceAnswer);
//# sourceMappingURL=SingleChoiceAnswer.js.map